import React from 'react';
import Stars from 'atomic/utilization/stars';
import Price from 'atomic/utilization/price';
import NumberOfOffer from 'atomic/number-of-offer';
import Carousel from 'components/carousel-multi/carousel-multi';
import Link from 'atomic/utilization/link';
import ProductListImpression from 'components/impressions/product-impression/list/product-list-impression';
import { ProductInterface } from 'interfaces/product.interface';

import './multi-carousel.scss';

interface MultiCarouselProductProps extends Pick<ProductInterface, 'id' | 'name' | 'url' | 'price' | 'photos'> {
    offers: {
        count: number;
        items: {
            id: number;
            dealer: {
                id: number;
                name: string;
            };
        }[];
    };
    opinions: {
        url: string;
        count: number;
        average: number;
    };
    category: {
        name: string;
    };
    producer: {
        name?: string;
    };
}

export interface MultiCarouselProductsProps {
    count: number;
    items: MultiCarouselProductProps[];
}

interface MultiCarouselProps {
    products: MultiCarouselProductsProps;
    itemsOnDesktop: number;
    itemsOnMobile: number;
    isMobile: boolean;
}

const MultiCarousel: React.FC<MultiCarouselProps> = ({ products, itemsOnDesktop, itemsOnMobile, isMobile }) => (
    <Carousel
        swipeable={true}
        draggable={false}
        slideNumberOnDesktop={itemsOnDesktop}
        slideNumberOnMobile={itemsOnMobile}
        renderButtonGroupOutside={true}
        arrows={false}
    >
        {
            products.items.map(product => (
                <Link href={product.url} key={product.id} title={product.name}>
                    <div className={`img-container${isMobile ? ' mobile' : ''}`}>
                        <ProductListImpression trackedData={product}>
                            <img
                                src={product.photos.main?.thumb}
                                alt={product.name}
                                loading="lazy"
                            />
                        </ProductListImpression>
                    </div>
                    <div className="stars-container">

                        {product.opinions && product.opinions.count > 0 && (
                            <>
                                <Stars className="xs" width={product.opinions.average}/>
                                (
                                {product.opinions.count}
                                )
                            </>
                        )}
                    </div>
                    <div className="title-container">
                        <h3 className="title">
                            {product.name}
                        </h3>
                    </div>
                    <div className="price-container">
                        <strong>
                            <span>
                                od
                            </span>
                            {' '}
                            <Price price={product.price}/>
                        </strong>
                    </div>
                    <NumberOfOffer offers={product.offers}/>
                </Link>
            ))
        }
    </Carousel>
);

export default MultiCarousel;
